/**
 * Плагин для установки контекста пользователя в Sentry
 * Чеклист:
 * ✅ Добавить контекст пользователя после логина (setUser)
 */
import { clearUserContext, setUserContext } from '~/src/utils/sentry';

export default defineNuxtPlugin(() => {
  const { data: session, status } = useAuth();

  // Следим за изменениями статуса аутентификации
  watch(
    [session, status],
    ([newSession, newStatus]) => {
      if (newStatus === 'authenticated' && newSession) {
        // Пользователь залогинился - устанавливаем контекст
        setUserContext({
          id: newSession.id || 'unknown',
          email: newSession.email || undefined,
          phone: newSession.phone || undefined,
          role: newSession.role || undefined,
        });
      } else if (newStatus === 'unauthenticated') {
        // Пользователь разлогинился - очищаем контекст
        clearUserContext();
      }
    },
    { immediate: true }
  );
});
